import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import { Button } from 'components'
import styles from './index.module.css'
import DetailTip from 'views/mydata/common/DetailTip';

const CareerResult = () => {

	const App = useApp()
	const [showLayer, setShowLayer] = useState(false)

	const openLayer = () => {
		setShowLayer(true)
	}

	const closeLayer = () => {
		setShowLayer(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding">
					<div className={styles.update}>
						2022.01.01 기준<i className="icon icon_update ml_10" />
					</div>
					<div className="flex-justify_between mt_10">
						<div className={styles["l-title"]}>
							지금까지 김모니님의 총 경력은<br /><strong>13년 10개월</strong>
						</div>
						<i className="icon icon_question" onClick={openLayer} />
					</div>

					{/* 재직회사가 하나일 경우 */}
					<div className={`${styles["company-info"]} mt_40`}>
						<div className={styles["company-title"]}>
							<p>주식회사 모니</p>
							<span className={styles["btn-txt"]}>회사조회</span>
						</div>
						<span className="mt_10">2021.01.01 ~ 재직중 (1년 10개월)</span>
					</div>

					{/* 재직회사가 여러개 일 경우 */}
					<div className="slider">
						<ul>
							<li>
								<div className={`${styles["company-info"]} mt_40`}>
									<div className={styles["company-title"]}>
										<p>주식회사 모니</p>
										<span className={styles["btn-txt"]}>회사조회</span>
									</div>
									<span className="mt_10">2021.01.01 ~ 재직중 (1년 10개월)</span>
								</div>
							</li>
						</ul>
						<ul className="slider-dots dots-gray mt_10">
							<li className="active" />
							<li />
							<li />
						</ul>
					</div>
				</div>
				<ul className="step-area list-bg">
					<li>
						<div>
							<div className="txt-area mt_0">
								<p>지역가입자</p>
								<span className="mt_10" style={{ color: "#666" }}>2017.02.25 ~ 2019.11.25 (2년 10개월)</span>
							</div>
							<span className="circle" />
						</div>
					</li>
					<li>
						<div>
							<div className="txt-area flex-justify_between align_center mt_0">
								<p>주식회사 핀테크</p>
								<span className={styles["btn-txt"]}>회사조회</span>
							</div>
							<span className="mt_10" style={{ color: "#666" }}>2016.08.01 ~ 2017.11.30 (1년 10개월)</span>
							<span className="circle" />
						</div>
					</li>
					<li>
						<div>
							<div className="txt-area flex-justify_between align_center mt_0">
								<p>주식회사 핀테크</p>
								<span className={styles["btn-txt"]}>회사조회</span>
							</div>
							<span className="mt_10" style={{ color: "#666" }}>2015.02.25 ~ 2016.11.25 (2년 10개월)</span>
							<span className="circle" />
						</div>
					</li>
					<li>
						<div>
							<div className="txt-area flex-justify_between align_center mt_0">
								<p>주식회사 핀테크</p>
								<span className={styles["btn-txt"]}>회사조회</span>
							</div>
							<span className="mt_10" style={{ color: "#666" }}>2012.08.01 ~ 2013.11.30 (1년 10개월)</span>
							<span className="circle" />
						</div>
					</li>
				</ul>
				<div className="padding pt_40 pb_50">
					<Button className="btn btn--big btn-more">+ 더보기</Button>
				</div>
			</div>
			<div className="padding">
				<h3>소득정보</h3>

				{/* 소득정보 case 01 */}
				<div className={`${styles["l-title"]} mt_30`} style={{ fontWeight: 300 }}>
					올해 소득은 작년 대비<br /><strong>10% 상승</strong>했어요!
				</div>
				<div className={`${styles["l-guide"]} mt_20`}>
					최근 3년동안 소득 <strong>인상률 평균은 5%</strong>에요.
				</div>
				<div className={`${styles["amount-graph"]} mt_30 pt_20 pl_60 mr_20`}>
					<ul>
						<li>
							<div>
								<div className={styles.bar}>
									<span style={{ height: "70%" }}>
										<span>2,500만원</span>
									</span>
								</div>
								<p>2019</p>
							</div>
						</li>
						<li>
							<div className={styles.bar}>
								<span style={{ height: "85%" }}>
									<span>3,000만원</span>
								</span>
							</div>
							<p>2020</p>
						</li>
						<li>
							<div className={`${styles.bar} ${styles.recent}`}>
								<span style={{ height: "100%" }}>
									<span>3,500만원</span>
								</span>
							</div>
							<p>2021</p>
						</li>
					</ul>
					<div className={styles.average} style={{ top: "5%" }}>
						<span>평균<br />3,000만원</span>
					</div>
				</div>

				{/* 소득정보 case 02 */}
				<div className={`${styles["l-title"]} mt_30`} style={{ fontWeight: 300 }}>
					올해 소득은 작년 대비<br /><strong className="text-red">10% 감소</strong>했어요!
				</div>
				<div className={`${styles["amount-graph"]} mt_30 pt_20 pl_60 mr_20`}>
					<ul>
						<li>
							<div>
								<div className={styles.bar}>
									<span style={{ height: 0 }}></span>
								</div>
								<p>2019</p>
							</div>
						</li>
						<li>
							<div className={styles.bar}>
								<span style={{ height: "100%" }}>
									<span>3,850만원</span>
								</span>
							</div>
							<p>2020</p>
						</li>
						<li>
							<div className={`${styles.bar} ${styles.recent}`}>
								<span style={{ height: "90%" }}>
									<span>3,500만원</span>
								</span>
							</div>
							<p>2021</p>
						</li>
					</ul>
					<div className={styles.average} style={{ top: 0 }}>
						<span>평균<br />3,700만원</span>
					</div>
				</div>

				{/* 소득정보 case 03 */}
				<div className={`${styles["l-title"]} mt_30`} style={{ fontWeight: 300 }}>
					올해 소득은 재작년 대비<br />변동이 없어요.
				</div>
				<div className={`${styles["amount-graph"]} mt_30 pt_20 px_40`}>
					<ul>
						<li>
							<div>
								<div className={styles.bar}>
									<span style={{ height: "100%" }}>
										<span>3,500만원</span>
									</span>
								</div>
								<p>2019</p>
							</div>
						</li>
						<li>
							<div className={styles.bar}>
								<span style={{ height: 0 }}></span>
							</div>
							<p>2020</p>
						</li>
						<li>
							<div className={`${styles.bar} ${styles.recent}`}>
								<span style={{ height: "100%" }}>
									<span>3,500만원</span>
								</span>
							</div>
							<p>2021</p>
						</li>
					</ul>
				</div>

				{/* 소득정보 case 04 */}
				<div className={`${styles["l-title"]} mt_30`} style={{ fontWeight: 300 }}>
					올해 소득은 과거 대비<br />변동 내역을 알 수 없어요.
				</div>
				<div className={`${styles["amount-graph"]} mt_30 pt_20 px_40`}>
					<ul>
						<li>
							<div>
								<div className={styles.bar}>
									<span style={{ height: 0 }}></span>
								</div>
								<p>2019</p>
							</div>
						</li>
						<li>
							<div className={styles.bar}>
								<span style={{ height: 0 }}></span>
							</div>
							<p>2020</p>
						</li>
						<li>
							<div className={`${styles.bar} ${styles.recent}`}>
								<span style={{ height: "100%" }}>
									<span>3,500만원</span>
								</span>
							</div>
							<p>2021</p>
						</li>
					</ul>
				</div>

				{/* 소득정보 case 05 */}
				<div className={`${styles["l-title"]} mt_30`} style={{ fontWeight: 300 }}>
					올해 소득은 정보가 없어요.<br />작년 소득은 재작년 대비<br /><strong className="text-red">10% 감소</strong>했어요!
				</div>
				<div className={`${styles["amount-graph"]} mt_30 pt_20 pl_60 mr_20`}>
					<ul>
						<li>
							<div>
								<div className={styles.bar}>
									<span style={{ height: "100%" }}>
										<span>3,850만원</span>
									</span>
								</div>
								<p>2019</p>
							</div>
						</li>
						<li>
							<div className={styles.bar}>
								<span style={{ height: "90%" }}>
									<span>3,500만원</span>
								</span>
							</div>
							<p>2020</p>
						</li>
						<li>
							<div className={`${styles.bar} ${styles.default}`}>
								<span style={{ height: 0 }}></span>
							</div>
							<p>2021</p>
						</li>
					</ul>
					<div className={styles.average} style={{ top: "4%" }}>
						<span>평균<br />3,700만원</span>
					</div>
				</div>

				{/* 소득정보 case 06 */}
				<div className={`${styles["l-title"]} mt_30`} style={{ fontWeight: 300 }}>
					올해 소득은 정보가 없어요.
				</div>
				<div className={`${styles["amount-graph"]} mt_30 pt_20 px_40`}>
					<ul>
						<li>
							<div>
								<div className={`${styles.bar} ${styles.default}`}>
									<span style={{ height: 0 }}></span>
								</div>
								<p>2019</p>
							</div>
						</li>
						<li>
							<div className={styles.bar}>
								<span style={{ height: "90%" }}>
									<span>3,500만원</span>
								</span>
							</div>
							<p>2020</p>
						</li>
						<li>
							<div className={`${styles.bar} ${styles.default}`}>
								<span style={{ height: 0 }}></span>
							</div>
							<p>2021</p>
						</li>
					</ul>
				</div>

				<Button className="btn btn--big btn-more mt_40">+ 더보기</Button>
			</div>
			<div className="padding">
				<div className={`${styles["life-guide-banner"]} ${styles["life-banner01"]}`}>
					<div className="pl_100">
						<span>궁금했던 회사가 있다면?</span>
						<p className="mt_5">사업자번호 입력만으로<br />기본정보부터 재무정보까지!</p>
					</div>
					<div className={styles.object} />
				</div>
			</div>

			<DetailTip title="총 경력이 다르게 나오나요?" show={showLayer} closeLayer={closeLayer}>
				<p>
					건강보험 자격득실 확인서의 가입자 구분이 ‘직장가입자’가
					아닐 경우, 총 경력에 포함되지 않아요.
				</p>
			</DetailTip>
		</div>
	)
}

export default CareerResult